export interface IAntibodyScreening {
    id: number,
    centerId: number,
    recipientId: number,
    is30Day: boolean,
    isAnnual: boolean,
    yearNumber: number,
    sentDate: string,
    resultsReceivedDate: string,
    resultsRawPath: string,
    resultsPdfPath: string,
    results: string,
    centerAlias: string,
    recipientAlias: string
}